import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { alerts as alertKeys, queryClient as qc } from "keys"
import { actions } from "store"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { backToTranscriptionFetch } from "store/middlewares/markingWords.crud"
import { useSelector } from "react-redux"


const useBackToConfirmation = () => {
    const dispatch = useDispatch()
    const queryClient = useQueryClient()
    const { assessment } = useSelector(state => state.assessment)

    const { mutateAsync: backToTranscriptionRQ, isPending: backToTranscriptionLoading } = useMutation({ mutationFn: backToTranscriptionFetch })

    const setBackToConfirmation = useCallback(async (value, props) => {
        dispatch(actions.setAlerts({
            key: alertKeys.backTo, value: {
                open: value,
                props: props,
                onClose: (props) => props.onClose(props)
            }
        }))
    }, [])

    const backToTranscription = useCallback(async (assessmentRow) => {
        const nAssessment = assessmentRow || assessment
        const res = await backToTranscriptionRQ(nAssessment)
        dispatch(actions.updateAssessment(res.data))
    }, [assessment])

    const openBackToTranscriptionConfirmation = useCallback(async (assessmentRow, refetchAfterBackTo) => {
        setBackToConfirmation(true, {
            title: "החזר לתעתוק",
            content: "האם התכוונת להחזיר את המבדק לתעתוק?",
            onConfirm: async () => {
                await backToTranscription(assessmentRow)
                setBackToConfirmation(false)
                if (refetchAfterBackTo)
                    await queryClient.invalidateQueries({
                        queryKey: [qc.adminAssessments],
                    })
            },
            onClose: () => {
                setBackToConfirmation(false)
            }
        })
    }, [])


    return {
        action: openBackToTranscriptionConfirmation,
        loading: backToTranscriptionLoading
    }
}

export default useBackToConfirmation